export default function logout() {
    axios
    .post('/JSONAPI',{
        cmdType:'SET_WEB_LOGOUT',
    })
    .then(response => {
        cookie.clear();
        $vm.$router.push("/");
    });
}